export default __webpack_public_path__ + "static/media/sameDayTimeSlotLogo.3e097e13.svg";